import type { ChangeEvent } from "react";
import { t } from "@/i18n-js/instance";
import { PAYWALL_STATUS } from "@circle-react/types/Paywall";
import {
  paywallStatusesDefault,
  usePaywallForm,
} from "@circle-react-shared/Paywalls/Modals/CreatePaywallSubscriptionModal/Form/hooks/usePaywallForm";
import { useBulkImportTrialPaywallSubscriptionFormContext } from "./BulkImportTrialPaywallSubscriptionFormProvider";
import { CustomFormItem } from "./CustomFormItem";
import { CustomSelectInput } from "./CustomSelectInput";

interface PaywallOption {
  label: string;
  value: string;
}

const noPaywallSelected: PaywallOption = {
  label: t("bulk_import_page.paywall.choose_paywall"),
  value: "",
};

export const PaywallForm = () => {
  const {
    paywallId,
    setPaywallId,
    skipDateValidations: shouldSkipDateValidations,
  } = useBulkImportTrialPaywallSubscriptionFormContext();
  const { paywallOptions } = usePaywallForm({
    communityMemberId: null,
    paywallStatuses: shouldSkipDateValidations
      ? paywallStatusesDefault
      : [PAYWALL_STATUS.ACTIVE],
  });

  const onPaywallChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setPaywallId(e.target.value ?? paywallId);
  };

  return (
    <CustomFormItem
      label={t("create_paywall_subscription_modal.form.paywall_id")}
    >
      <CustomSelectInput
        name="paywall[paywall_id]"
        options={[noPaywallSelected, ...paywallOptions]}
        onChange={onPaywallChange}
        value={paywallId}
      />
    </CustomFormItem>
  );
};
